import { Dependency } from './dependency'
import { Component } from 'js/lib/components/component'
import { DEPENDENCY_UPDATE_EVENT } from './events'

const FORMS = new Map()

class Form extends Component {
  // defaults
  dependencies = []
  state = {}

  initialize() {
    this.state = this.getFormState()

    FORMS.set(this.element, this)

    // If there are dependencies then initialize them and start listening to them
    if (this.state?.dependencies?.length) {
      this.dependencies = Dependency.fromList(this.state.dependencies, this)
      this.connectWithDeps()
    }
  }

  disableSubmitButtons() {
    const submitBtns = this.element.querySelectorAll('button[type="submit"]')
    submitBtns.forEach(btn => (btn.disabled = true))
  }

  // Use the components "useHandler" for adding event listeners so they can be re-done
  on(type, listener) {
    this.useHandler(() => {
      this.element.addEventListener(type, listener)
      return () => this.element.removeEventListener(type, listener)
    })
  }

  dispatchEvent(type, payload) {
    const event = new window.CustomEvent(type, { detail: payload, bubbles: true, cancelable: true })
    this.element.dispatchEvent(event)
  }

  willUnmount() {
    FORMS.delete(this.element)
  }

  connectWithDeps() {
    if (this.listeningForInputDependencyChanges === true) return
    const trackingFieldNames = this.dependencies.map(dep => dep.trackingFieldName)

    const triggerEvent = (event, eventType) => {
      const target = event.target

      if (!target.matches('input, textarea, select')) return
      if (!trackingFieldNames.includes(target.name)) return

      this.dispatchEvent(DEPENDENCY_UPDATE_EVENT, { targetName: target.name, eventType })
    }

    this.on('input', event => triggerEvent(event, 'input'))
    this.on('change', event => triggerEvent(event, 'change'))

    this.listeningForInputDependencyChanges = true
  }

  getFormState() {
    const script = this.element.querySelector('script.js-c-form-state')
    if (!script) return undefined
    return JSON.parse(script.textContent)
  }
}

Form.register('form.js-c-application-form')

export function useForm(formElement) {
  return FORMS.get(formElement)
}
